import { tarifFrance } from '@europrocurement/l2d-utils';
import { Tooltip, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

export type PanierReglementRecapElementProps = {
    title: string;
    subtitle?: string;
    prix: string;
};

const PanierReglementRecapElement: React.FunctionComponent<PanierReglementRecapElementProps> =
    function (props) {
        const theme = useTheme();
        const { title, prix, subtitle } = props;
        return (
            <Box
                sx={{
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    alignItems: 'center',
                    gap: '5px',
                    justifyContent: 'space-between',
                    '&:last-child ': { borderBottom: 'none' },
                }}
            >
                <Box>
                    <Typography variant="l2dlabel">{title}</Typography>

                    {subtitle && (
                        <Tooltip title={subtitle}>
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    fontWeight: '300',
                                }}
                            >
                                {subtitle}
                            </Typography>
                        </Tooltip>
                    )}
                </Box>
                <Typography
                    display="flex"
                    variant="l2dlabel"
                    gap="5px"
                    sx={{
                        fontWeight: 600,
                        textAlign: 'right',
                    }}
                >
                    {tarifFrance(prix as unknown as number)}
                </Typography>
            </Box>
        );
    };

export default PanierReglementRecapElement;
